import { Checkbox, FormControlLabel } from "@material-ui/core";
import React from "react";
import { ValidatorComponent } from "react-material-ui-form-validator";

class InputCheckboxLabel extends ValidatorComponent {
  render() {
    const {
      errorMessages,
      validators,
      requiredError,
      label,
      value,
      ...rest
    } = this.props;

    return (
      <div style={{ marginTop: 10, marginBottom: 10 }}>
        <FormControlLabel
          control={
            <Checkbox
              {...rest}
              ref={(r) => {
                this.input = r;
              }}
            />
          }
          label={label}
        />
        {this.errorText()}
      </div>
    );
  }

  errorText() {
    const { isValid } = this.state;

    if (isValid) {
      return null;
    }

    return (
      <p className="MuiFormHelperText-root MuiFormHelperText-contained Mui-error">
        {this.getErrorMessage()}
      </p>
    );
  }
}

export default InputCheckboxLabel;
